import React from 'react';
import { Flex, HStack, Image, Text } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useMedia from '../../Utils/useMedia';

import logo from '../../Resources/Images/Logos/logo.svg';

const Navbar: React.FC = () => {
  const { isDesktop } = useMedia();
  const { t } = useTranslation();
  const location = useLocation();

  const navLinks = [
    { path: '/', text: t('navbar.home') },
    { path: '/vc-application', text: t('navbar.vcApplication') },
    { path: '/comingsoon', text: t('navbar.vcVerification') },
    { path: '/dcertupload', text: t('navbar.certificateVerification') },
  ];

  const isLinkActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <Flex
      as="header"
      position="sticky"
      top="0"
      zIndex="999"
      w="100%"
      h="88px"
      px={{ base: '16px', md: '24px', lg: '30px' }}
      py="23px"
      justify="space-between"
      align="center"
      bg="#FFFFFF"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      <NavLink to="/" style={{ textDecoration: 'none' }}>
        <Image
          src={logo}
          alt="數位證明管理中心"
          h={{ base: '40px', md: '44px', lg: '48px' }}
          w="auto"
          objectFit="contain"
          display="block"
        />
      </NavLink>

      {isDesktop && (
        <HStack as="nav" spacing="22px">
          {navLinks.map((link) => {
            const active = isLinkActive(link.path);

            return (
              <NavLink key={link.path} to={link.path} style={{ textDecoration: 'none' }}>
                <Flex
                  h="37px"
                  px="12px"
                  py="8px"
                  align="center"
                  justify="center"
                  borderRadius="4px"
                  bg={active ? '#008DD4' : '#00AAFF'}
                  transition="background-color 0.2s ease"
                  _hover={{
                    bg: active ? '#008DD4' : '#0099E6',
                  }}
                >
                  <Text
                    fontSize="14px"
                    fontWeight="400"
                    lineHeight="150%"
                    letterSpacing="0.01em"
                    color="#FFFFFF"
                    whiteSpace="nowrap"
                  >
                    {link.text}
                  </Text>
                </Flex>
              </NavLink>
            );
          })}
        </HStack>
      )}
    </Flex>
  );
};

export default Navbar;
